/* pd-more-deals — tabs 切换 + product swap
   Care modal + care benefits 切换走共享 assets/pd-bp-care-modal.js。 */
(function () {
  'use strict';
  if (window.customElements.get('pd-more-deals')) return;

  // 切 tab/deal 时，隐藏内容（display:none）里的懒加载图不会下载，切换才请求 → 白屏。
  // 空闲时提前拉好：lazysizes 图（class="lazyload"）调 loader.unveil()，原生 lazy 图转 eager。
  function preloadLazyImages(root) {
    var imgs = root.querySelectorAll('img.lazyload, img[loading="lazy"]');
    if (!imgs.length) return;
    var lz = window.lazySizes;
    var run = function () {
      imgs.forEach(function (img) {
        if (img.classList.contains('lazyload')) {
          if (lz && lz.loader && lz.loader.unveil) lz.loader.unveil(img);
        } else if (img.getAttribute('loading') === 'lazy') {
          img.loading = 'eager';
        }
      });
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 2000 });
    else setTimeout(run, 600);
  }

  class PdMoreDeals extends HTMLElement {
    connectedCallback() {
      if (this._inited) return;
      this._inited = true;

      var tabs = this.querySelectorAll('[data-pd-md-tab]');
      var cards = this.querySelectorAll('[data-pd-md-card]');
      if (tabs.length) {
        var applyTab = function (id) {
          tabs.forEach(function (b) {
            var active = b.getAttribute('data-pd-md-tab') === id;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          cards.forEach(function (c) {
            c.classList.toggle('pd-more-deals__card--hidden', c.getAttribute('data-pd-md-card') !== id);
          });
        };
        tabs.forEach(function (b) {
          b.addEventListener('click', function () {
            applyTab(b.getAttribute('data-pd-md-tab'));
          });
        });
      }

      this.querySelectorAll('[data-pd-md-product-select]').forEach(function (dd) {
        var card = dd.closest('[data-pd-md-card]');
        if (!card) return;
        var applyProd = function (id) {
          card.querySelectorAll('[data-pd-md-prod]').forEach(function (el) {
            el.classList.toggle('is-active', el.getAttribute('data-pd-md-prod') === id);
          });
        };
        if (window.PdBpDropdown && window.PdBpDropdown.init) {
          window.PdBpDropdown.init(dd, { onChange: applyProd });
        }
      });

      preloadLazyImages(this);
    }
  }

  window.customElements.define('pd-more-deals', PdMoreDeals);
})();
